import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../Components/Header";

export default function DisableGoogleMaps() {
  const navigate = useNavigate();
  const [show, setShow] = useState(true);

  useEffect(() => {
    localStorage.setItem("disableGoogleMaps", "true");

    const t = setTimeout(() => {
      setShow(false);
      navigate("/", { replace: true });
    }, 4000);

    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />

      <section
        className="
          flex-1
          relative left-1/2 right-1/2 -mx-[50vw] w-screen
          bg-white  /* same bg as header */
          flex items-start md:items-center justify-center
          py-8 md:py-0
        "
      >
        {show && (
          <div className="bg-white/95 backdrop-blur p-6 md:p-8 rounded-2xl shadow-[0_30px_60px_-15px_rgba(0,0,0,0.25)] text-center">
            <h2 className="text-2xl font-semibold text-gray-900 mb-1 mt-4">
              Thanks!
            </h2>
            <p className="text-gray-600 mt-4">
              Google Maps is now disabled.
            </p>

            <p className="text-gray-600">
              Redirecting you back to the start...
            </p>

            <div className="mx-auto mb-4" aria-hidden="true">
              <svg
                width="42"
                height="42"
                viewBox="0 0 24 24"
                style={{
                  animation: "spin 1s linear infinite",
                  display: "block",
                  margin: "0 auto",
                }}
              >
                <circle
                  cx="12"
                  cy="12"
                  r="9"
                  stroke="rgba(0,0,0,0.15)"
                  strokeWidth="3"
                  fill="none"
                />
                <path
                  d="M21 12a9 9 0 0 0-9-9"
                  stroke="#06b6d4"
                  strokeWidth="3"
                  fill="none"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          </div>
        )}
      </section>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
